export default __webpack_public_path__ + "/dist/images/billing-active.ca2c2d0a1670d56466a910aa87c1617b.svg";